import React from 'react';
import { ReactComponent as Icon } from '../../../assets/icon-active-tab.svg';
import createSvgIcon from '../../../shared/utils/create-svg-icon';

export const ActiveTabIcon = createSvgIcon(<Icon />, 'ActiveTabIcon');
